import firebase from 'firebase/app'
import 'firebase/firebase-auth'
import 'firebase/firebase-firestore'
import 'firebase/firebase-database'
import 'firebase/firebase-storage'
import 'firebase/firebase-messaging'
import 'firebase/performance'
import 'firebase/analytics'
import { storageAvailable } from './navigatorApi'
////////////////////////
import { FIREBASE_PUBLIC_CONFIG } from '../config/public'
/////////
///////////////////////////////////////////////////////
//////////
let FIREBASE_CONFIG
////////////////////////
FIREBASE_CONFIG = FIREBASE_PUBLIC_CONFIG
/////////
///////////////////////////////////////
////////////////////////////////////////
//////////
let apiURL = ''
if (process.env.NODE_ENV === 'production') {
//////////////////////////
  apiURL = 'https://us-central1-cuidarte-app.cloudfunctions.net/api'
///////////
////////////////////////////////////////////////////////////////
////////////
} else {
  apiURL = 'http://localhost:5002/cuidarte-app/us-central1/api'
  // console.info(FIREBASE_CONFIG)
  // console.info('DEV', apiURL)
}
export { apiURL, FIREBASE_CONFIG }

export const firebaseApp = firebase.initializeApp(FIREBASE_CONFIG)
export const firebaseAuth = firebaseApp.auth()
export const emailProvider = firebase.auth.EmailAuthProvider
export const firebaseDb = firebaseApp.database()
export const perf = firebase.performance()
export const analytics = firebase.analytics()
export const firebaseStorage = firebase.storage
export const FieldValue = firebase.firestore.FieldValue
let messaging
if (process.env.NODE_ENV === 'production' && firebase.messaging.isSupported()) {
  messaging = firebaseApp.messaging()
} else {
  messaging = null
}
export const firebaseMessaging = messaging
const firestore = firebase.firestore()
if (localStorage.getItem('allowPersistance') === 'true') {
  firestore.enablePersistence()
    .catch(err => {
      if (err === 'failed-precondition') {
        console.error('La app esta abierta en otra pestaña.')
      } else if (err === 'unimplemented') {
        console.error('Este navegador no soporta la persistencia.')
      }
    })
}
export const db = firestore
export const timestamp = firebase.firestore.Timestamp
export const GeoPoint = firebase.firestore.GeoPoint
firebase.analytics()

require('./indexDBPolyfill')

const clearDBs = (dbs) => {
  return new Promise((resolve) => {
    const total = dbs.length
    let totalSuccess = 0
    let totalError = 0
    console.info(total)
    if (total === 0) resolve({ totalSuccess: 0, totalError: 0 })
    dbs.forEach(db => {
      const IDBRequest = window.indexedDB.deleteDatabase(db.name)
      console.info(IDBRequest)
      IDBRequest.onblocked = () => {
        if (totalSuccess + totalError + 1 === total) resolve({ totalSuccess, totalError })
        totalError += 1
      }
      IDBRequest.onsuccess = () => {
        console.info('success')
        if (totalSuccess + totalError + 1 === total) resolve({ totalSuccess, totalError })
        totalSuccess += 1
      }
      IDBRequest.onerror = () => {
        console.info('error')
        if (totalSuccess + totalError + 1 === total) resolve({ totalSuccess, totalError })
        totalError += 1
      }
    })
  })
}

export const firebaseTools = {
  // Returns verificationId
  signInWithPhoneNumber: (phoneNumber, applicationVerifier) => {
    return firebaseAuth.signInWithPhoneNumber(phoneNumber, applicationVerifier)
  },
  getRecaptchaVerifier: (selector, cb, ecb) => {
    return new firebase.auth.RecaptchaVerifier(selector, {
      size: 'invisible',
      callback: cb || function () {},
      expiredCallback: ecb || function () {},
    })
  },
  getDatabaseReference: {
    default: path => firebaseDb.ref(path),
  },
  initRealm: (realmURL) => {
    if (typeof firebaseTools[realmURL] === 'undefined') {
      firebaseTools.getDatabaseReference[realmURL] = path => firebaseApp.database(realmURL).ref(path)
    }
  },
  getCurrentUserJWT: (refresh) => new Promise((resolve, reject) => {
    firebaseAuth.currentUser.getIdToken(true)
      .then((idToken) => {
        resolve(idToken)
      }).catch((err) => {
        reject(err)
      })
  }),
  signOut: async () => {
    if (storageAvailable('localStorage')) {
      localStorage.clear()
      const dbs = await window.indexedDB.databases()
      const results = await clearDBs(dbs)
      console.info(results)
      window.history.pushState('', '', process.env.BASE_URL)
    }
    return firebaseAuth.signOut()
  },
  linkAccount: (providerSelected) => new Promise((resolve, reject) => {
    let provider
    switch (providerSelected) {
      case 'google':
        provider = new firebase.auth.GoogleAuthProvider()
        provider.addScope('https://www.googleapis.com/auth/userinfo.email')
        break
      default:
        reject(new Error('Provider not configured'))
        break
    }
    firebaseAuth.useDeviceLanguage()
    firebaseAuth.currentUser.linkWithPopup(provider).then(function (result) {
      var credential = result.credential
      var user = result.user
      resolve({ credential, user })
    }).catch(function (error) {
      reject(error)
    })
  }),
}
